module.exports = __webpack_public_path__ + "static/WEDDING E&M-387-1a8baa433ce532d20b0084dcebed5ac4.jpg";